//
//
//
//
//
//
//
//
//
//

import ButtonMenu from "~/components/ButtonMenu";
import ParliamentarianList from "~/components/parliamentarian/ParliamentarianList.vue";
import ParliamentarianListFilter from "~/components/parliamentarian/ParliamentarianListFilter.vue";

export default {
	name: "parliamentarian-index",
	components: {
		ButtonMenu,
		ParliamentarianList,
		ParliamentarianListFilter,
	},
	async asyncData({ $axios, app, store }) {
		if (!store.state.init) await store.dispatch("init");
	},
	nuxtI18n: {
		paths: {
			en: "/parliamentarian",
			de: "/parlamentarier_innen",
			fr: "/membre-du-parlement",
			it: "/parlamentare",
		},
	},
	head() {
		return {
			title: this.$t(`parliamentarian`),
		};
	},
};
